export const ADVENTURE_SETUP_ID = 'adventure-setup'

export function replyAnchorId(replyId) {
  return `reply-${replyId}`
}

/**
 * Parse adventure hash anchors. Ignores visible post numbers (#0, #47).
 * @returns {{ type: 'setup' } | { type: 'reply', replyId: string | number } | null}
 */
export function parseAdventureHash(hash) {
  const raw = (hash || '').replace(/^#/, '').trim()
  if (!raw) return null

  if (raw === ADVENTURE_SETUP_ID) {
    return { type: 'setup' }
  }

  const replyMatch = raw.match(/^reply-(\d+)$/i)
  if (replyMatch) {
    return { type: 'reply', replyId: replyMatch[1] }
  }

  return null
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/**
 * Scroll to a stable adventure anchor, retrying until the DOM node exists.
 * @returns {Promise<boolean>} true if scroll was performed
 */
export async function scrollToAdventureAnchor(
  elementId,
  { behavior = 'smooth', block = 'center', maxAttempts = 20, intervalMs = 50 } = {}
) {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const el = document.getElementById(elementId)
    if (el) {
      try {
        el.scrollIntoView({ behavior, block })
      } catch {
        el.scrollIntoView()
      }
      return true
    }

    if (attempt < maxAttempts - 1) {
      await sleep(intervalMs)
    }
  }

  return false
}
